import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';

import ControlledNumericField from 'components/shared/ControlledFields/ControlledNumericField';

type Props = {
  duty: string;
  nominal: string;
  percent: string;
};

export default function NumericFieldSection({ duty, nominal, percent }: Props) {
  const { t } = useTranslation();

  return (
    <Box display="flex" gap={2.5} maxWidth={440} paddingBottom={2}>
      <ControlledNumericField
        name={duty}
        variant="outlined"
        label={t('surchargesMaintenance.form.' + duty)}
        step={1}
      />
      <ControlledNumericField
        name={nominal}
        variant="outlined"
        label={t('surchargesMaintenance.form.' + nominal)}
        step={1}
      />
      <ControlledNumericField
        name={percent}
        variant="outlined"
        label={t('surchargesMaintenance.form.' + percent)}
        step={1}
        defaultValue={0}
      />
    </Box>
  );
}
